import React from "react";
import GiftList from "../../components/management/gift-list/GiftList";
import UserInviteForm from "../../components/management/user-invite-form/UserInviteForm";
import UserInvitedList from "../../components/management/user-invited-list/UserInvitedList";
import UserPointList from "../../components/management/user-point-list/UserPointList";
import UserPoint from "../../components/management/user-point/UserPoint";
import './RewardRoute.scss';

export default class RewardRoute extends React.PureComponent<{ statusPage?: string | null }, { statusPage: number }> {
    userInvitedListRef: React.RefObject<UserInvitedList>;

    constructor(props: any) {
        super(props);
        this.userInvitedListRef = React.createRef();
        this.state = { statusPage: 1 };
    }

    componentDidMount() {
        if (this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.statusPage !== this.props.statusPage && this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    reload() {
        this.userInvitedListRef.current?.getData()
    }

    render(): React.ReactNode {
        let { statusPage } = this.state;

        return (<>
            <div className="content-menu reward-route-area px-4">
                <div className="col-12">
                    <div className="tk-inline" style={{ marginBottom: "3px" }}>
                        <div className={"col-4 notspace header-title " + (statusPage === 1 ? "active" : "")} onClick={() => this.setState({ statusPage: 1 })}>
                            <label>دعوت دوستان</label>
                        </div>
                        <div className={"col-4 notspace header-title " + (statusPage === 2 ? "active" : "")} onClick={() => this.setState({ statusPage: 2 })}>
                            <label>امتیازات</label>
                        </div>
                        <div className={"col-4 notspace header-title " + (statusPage === 3 ? "active" : "")} onClick={() => this.setState({ statusPage: 3 })}>
                            <label>جوایز</label>
                        </div>
                    </div>
                </div >
                <div className="dropdown-list reward-route-area">
                    <div className="tk-aling-right tk-padding-top">
                        <div className="col-12">
                            {this.contentView(statusPage)}
                        </div>
                    </div>
                </div>
            </div >
        </>);
    }
    contentView = (statusPage: number) => {
        if (statusPage === 1) {
            return (<>
                <UserInviteForm reload={this.reload.bind(this)} />
                <UserInvitedList ref={this.userInvitedListRef} />
            </>)
        }
        if (statusPage === 2) {
            return (<>
                <UserPoint />
                <UserPointList />
            </>)
        }
        if (statusPage === 3) {
            return (<>
                <GiftList />
            </>)
        }
    }
}